import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'

import { KidNorwayTransaction } from '../../tables/KidNorwayTransaction'

export const kidNorwayTransactionsColumns: ColumnDef<KidNorwayTransaction.ListItem>[] = [
  {
    accessorKey: 'customer.name',
  },
  {
    accessorKey: 'customer.email',
  },
  // {
  //   accessorKey: 'connectedAccount.name',
  // },
  {
    accessorKey: 'payment.description',
  },
  {
    accessorKey: 'amount',
  },
  {
    accessorKey: 'payment.grossAmount',
  },
  {
    accessorKey: 'payment.paymentStatus',
  },
  {
    accessorKey: 'payment.description',
  },
  {
    accessorKey: 'kid',
  },
  {
    accessorKey: 'fromBankAccount',
  },
  {
    accessorKey: 'insertTime',
  },
  {
    id: 'actions',
    size: 40,
    cell: ({ row }) => {
      return h(
        'div',
        { style: { display: 'flex', justifyContent: 'end' } }
        // h(DataTableGoto, {
        //   name: 'Payment',
        //   id: getColumnByStringIndex(payment, getDefaultColumn('payments').id),
        //   pathName: 'payment',
        // })
      )
    },
  },
]
